export default "__VITE_ASSET__BU0fcMjZ__"